import { correctPublishedResearch, CorrectPublishedResearchPayload } from '@/api/business/marketResearch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ResearchedProductKeys } from './useResearchedProductQuery'
import { ResearchAuditKeys } from './useResearchAuditHistoryQuery'

export const useCorrectPublishedResearchMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CorrectPublishedResearchPayload) => correctPublishedResearch(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ResearchedProductKeys.all })
      queryClient.invalidateQueries({ queryKey: ResearchAuditKeys.all })
    },
  })
}
